@if (strategy.dip && !isMobile) {
  <div
    class="dip-desktop-stamp"
    [ngClass]="{'dip-desktop-stamp--carouseled': inCarousel}"
    data-cy="dip-desktop-card-stamp"
    >
    <p class="dip-stamp-text-desktop">
      {{ 'global.dipShortcut' | translate }}
    </p>
  </div>
}
@if (isDraft && !strategy.dip && !isMobile) {
  <div
    class="draft-consultant-avatar desktop"
    [ngClass]="{'draft-consultant-avatar--carouseled': inCarousel}"
    data-cy="draft-consultant-avatar-desktop"
    >
    <img [src]="strategy.consultantPhoto" alt="consultant photo" />
  </div>
}
@if (strategy) {
  <div
    class="strategy-card"
  [ngClass]="{
    'toggled': toggled,
  }"
    [attr.data-cy]="strategy.portfolioType + '-owned-card-container' + (isDraft ? '-draft-card' : '') + (isMobile ? '-mobile' : '-desktop')"
    >
    <div
      class="card-header"
      (click)="isMobile && (toggled = !toggled)"
      (keydown.space)="isMobile && (toggled = !toggled)"
      (keydown.enter)="isMobile && (toggled = !toggled)"
      tabindex="0"
      >
    <div class="card-header-layout" [ngClass]="{
      'draft-investment-type': isDraft,
      'draft-mobile-avatar': toggled && isDraft && !strategy.dip,
      'draft-desktop': isDraft && !isMobile,
      'draft-toggled': toggled && isDraft && isMobile
    }">
        @if (isDraft && !strategy.dip && isMobile) {
          <div
            class="draft-consultant-avatar mobile"
            [ngClass]="{'draft-consultant-avatar--carouseled': inCarousel}"
            data-cy="draft-consultant-avatar-mobile"
            >
            <img [src]="strategy.consultantPhoto" alt="consultant photo" />
          </div>
        }
        @if (strategy.dip) {
          <p class="dip-stamp-text" data-cy="dip-stamp-text-mobile">{{ 'global.dipShortcut' | translate }}</p>
        }
        <ng-template #investmentType>
          <div class="investment-type" data-cy="header-investment-type">
            @if (!isDraft) {
              {{ (strategy.portfolioType === 'STRATEGY' ? 'strategyCard.strategy' : 'strategyCard.portfolio') | translate }}
            }
            @if (isDraft) {
              {{ 'money.draftLabel' | translate }}
              @if (strategy.portfolioType === 'STRATEGY') {
                {{ 'money.strategyGen' | translate }}
              } @else {
                {{ 'money.portfolioGen' | translate }}
              }
            }
          </div>
        </ng-template>
        <!-- Show two-lined header for toggled mobile draft card and for desktop card-->
        @if ((isDraft && toggled && isMobile) || (isDraft && !toggled && !isMobile)) {
          <div>
            <ng-template [ngTemplateOutlet]="investmentType"></ng-template>
            <span class="card-header-wrapper" data-cy="draft-two-lined-header">
              &#34;<div class="card-header--name">{{ strategy.name }}</div>&#34;
            </span>
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="investmentType"></ng-template>
          &#34;<div class="card-header--name">{{ strategy.name }}</div>&#34;
        }
      </div>
      <span class="phone-btn">
        @if (!toggled) {
          <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18 }"></svg-icon>
        } @else {
          <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(180deg)' }"></svg-icon>
        }
      </span>
    </div>
    <div class="phone-content" [ngClass]="{ 'toggled': toggled, 'draft-card': isDraft }" data-cy="card-togglable-content">
      @if (!isDraft) {
        <div class="card-value">
          <div class="strategy-card--label actual-value">
            {{ 'strategyCard.actualValue' | translate }}
          </div>
          <div class="strategy-card--value" data-cy="investment-value">
            {{ strategy.sumAmount | price:strategy.currency }}
          </div>
        </div>
      }
      <div class="row gx-0 mt-3">
        @if (!isDraft) {
          <div class="col-5">
            <div class="strategy-card--label">
              {{ 'strategyCard.actualProfit' | translate }}
            </div>
            <div class="card-profit-value" [ngClass]="{ 'positive': positiveYield }" data-cy="actual-yield">
              {{ strategy.actualYield | price:strategy.currency }}
            </div>
          </div>
        }
        <div [ngClass]="isDraft ? 'col-5 draft-order-1' : 'col-7'">
          <div class="card-regular-investment">
            <div class="strategy-card--label">
              {{ 'strategyCard.investmentPeriod' | translate }}
            </div>
            <div class="card-profit-value" data-cy="total-years-to-invest">
              {{ strategy.totalYearsToInvest | currencyDigitShortcut: yearsShortcutsOptions }}
            </div>
          </div>
        </div>
        <div [ngClass]="{ 'col-5 mt-4': true, 'draft-order-3': isDraft}">
          <div class="strategy-card--label">
            {{ 'strategyCard.regularInvestment' | translate }}
          </div>
          <div class="card-profit-value" data-cy="regular-investment">
            {{ strategy.regularDeposit | price:strategy.currency }}
          </div>
        </div>
        <div [ngClass]="{ 'col-7': true, 'draft-order-2': isDraft, 'mt-4': !isDraft}">
          <div class="card-investment-frequency">
            <div class="strategy-card--label">
              {{ 'strategyCard.investmentFrequency' | translate }}
            </div>
            <div class="card-profit-value" data-cy="investment-frequency">
              {{ strategy.weeksBetweenInvestments | investmentFrequency | translate }}
            </div>
          </div>
        </div>
        <div class="col-12 mt-4 draft-order-3">
          <div class="strategy-card--label">
            {{ 'strategyCard.oneTimeInvestment' | translate }}
          </div>
          <div class="card-profit-value">
            {{ strategy.initialDeposit | price:strategy.currency }}
          </div>
        </div>
      </div>
      @if (strategy.portfolioType === 'PORTFOLIO') {
        <div class="strategy-card--label mt-4" data-cy="expected-value-in-target-year-label">
          {{ 'strategyCard.expectedValueYear' | translate }} {{ isDraft ? getTargetYearForDraft() : strategy.targetYear }}:
        </div>
        <div class="card-expected-value" data-cy="expected-value-in-target-year">
          {{ strategy.expectedValueInTargetYear | price:strategy.currency }}
        </div>
      } @else {
        <div class="expected-value-vertical-placeholder"></div>
      }
      @if (strategy.riskScore) {
        <div class="card-risk mt-4" data-cy="risk-score-slider">
          <div class="strategy-card--label">
            {{ 'strategyCard.riskProfile' | translate }}
          </div>
          <div class="slidecontainer">
            <input disabled type="range" min="1" max="{{ sliderMax }}" [value]="strategy.riskScore">
          </div>
          <div class="risk-bar mt-1">
            @for (riskLevel of riskLevels; track riskLevel) {
              <div class="legend" [ngClass]="{ 'legend--active': riskLevel === strategy.riskScore }">
                {{ riskLevel }}
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="portfolio-risk-vertical-placeholder"></div>
      }
      @if (!isDraft) {
        <div class="buttons-container">
          <div class="text-center">
            <libero-button
              label="{{ 'global.detail' | translate }}"
              btnClasses="btn--secondary btn--small"
              routerLink="/investment-detail/{{strategy.portfolioId}}"
              data-cy="owned-card-detail-link"
              [attr.data-cy-dynamic]="'owned-card-detail-link-' + strategy.portfolioType"
            ></libero-button>
          </div>
          <div class="mt-3 text-center">
            <libero-button
              label="{{ 'global.insertCash' | translate }}"
              btnClasses="btn--primary btn--small"
              (click)="openMoneyDepositModal()"
            ></libero-button>
          </div>
          <div class="mt-4 text-center">
            <libero-button
              label="{{ 'global.buttons.edit' | translate }} {{ (strategy.portfolioType === 'STRATEGY' ? 'global.buttons.strategy' : 'global.buttons.portfolio') | translate }}"
              btnClasses="btn--secondary btn--card-action"
              svgIcon="pencil"
              [iconWidth]="16"
              [routerLink]="[strategy.portfolioType === 'STRATEGY' ?  '/strategy/edit/' + strategy.portfolioId : '/portfolio/edit/' + strategy.portfolioId, { origin: 'summary'}]"
              [attr.data-cy]="'owned-card-edit-button-' + strategy.portfolioType"
              [preloader]="loadingForStrategyEdit"
              (click)="loadStrategyEditForPMWithStrategies()"
              [preloaderInverse]="false"
              [smallSecondary]="true"
            ></libero-button>
          </div>
          <div class="mt-4 text-center">
            <libero-button
              label="{{ 'global.buttons.delete' | translate }} {{ (strategy.portfolioType === 'STRATEGY' ? 'global.buttons.strategy' : 'global.buttons.portfolio') | translate }}"
              btnClasses="btn--secondary btn--card-action"
              svgIcon="trash"
              [iconWidth]="16"
              [buttonDisabled]="!strategy.canRemovePortfolio"
              (click)="strategy.canRemovePortfolio ? deleteInvestment() : null"
              [attr.data-cy]="'owned-card-delete-button-' + strategy.portfolioType"
              [disabledTooltipText]="!strategy.canRemovePortfolio ? (strategy.portfolioType === 'STRATEGY' ? 'notDeletableStrategy' : 'notDeletablePortfolio') : null"
            ></libero-button>
          </div>
        </div>
      } @else {
        <div class="buttons-container">
          <div class="text-center">
            <libero-button
              label="{{ 'global.detail' | translate }}"
              btnClasses="btn--secondary btn--small"
              [routerLink]="['/investment-detail/' + strategy.draftPortfolioId, { isDraft: isDraft ? 1 : 0 }]"
              data-cy="draft-detail-btn"
            ></libero-button>
          </div>
          @if (strategy.aml) {
            <div class="mt-4 text-center">
              <libero-button
                label="{{ 'global.accept' | translate }}"
                btnClasses="btn--primary btn--small"
                (click)="openDraftAcceptRefuseConfirm(strategy, 'accept')"
                data-cy="draft-accept-btn"
                [buttonDisabled]="!strategy.canAcceptDraft"
                disabledTooltipText="instrumentsNotAllowedForDraftAccept"
              ></libero-button>
            </div>
          }
          @if (!strategy.aml) {
            <div class="mt-4 text-center">
              <libero-button
                label="{{ 'global.buttons.updateAml' | translate }}"
                [uppercase]="false"
                btnClasses="btn--secondary btn--small btn--danger-border btn--aml"
                (click)="goToAMLForm()"
                data-cy="draft-update-aml-btn"
              ></libero-button>
            </div>
          }
          <div class="mt-4 text-center">
            <libero-button
              label="{{ 'global.refuse' | translate }}"
              btnClasses="btn--danger btn--small"
              (click)="openDraftAcceptRefuseConfirm(strategy, 'refuse')"
              data-cy="draft-refuse-btn"
            ></libero-button>
          </div>
        </div>
      }
    </div>
    @if (isDraft) {
      <div class="draft-card-footer">
        <div class="draft-expiration" data-cy="draft-expiration-text">
          <svg-icon src="assets/icons/clock.svg" [svgStyle]="{ 'width.px':22, 'height.px':22, 'transform': 'translateY(-2px)' }"></svg-icon>
          <span class="ml-2">
            {{ 'strategyCard.draftCardFooter.common1' | translate }}
            {{ (strategy.portfolioType === 'STRATEGY' ? 'strategyCard.draftCardFooter.strategy' : 'strategyCard.draftCardFooter.portfolio') | translate }}
            {{ 'strategyCard.draftCardFooter.common2' | translate }}
          </span>
          <span class="text-success">
            {{ strategy.autoExpiryTime | dayDiff }}
          </span>
        </div>
      </div>
    }
  </div>
}
